export default __webpack_public_path__ + "static/media/squares800.8509f484.jpg";